import { useLangContext } from '../../../providers/LangProvider/LangProviderContext';
import { UserStatusRespawnStyled } from './styled/UserStatusRespawnStyled';
import BinIcon from '../../../components/icon/IconWrapped';
import React from 'react';
import UserStatusWidgetWrapper from './UserStatusWidgetWrapper';

function UserStatusRespawn() {
    const { getLangPath } = useLangContext();

    return <UserStatusWidgetWrapper
        toggleComponent={<UserStatusRespawnStyled className={'inactive'}>
            <BinIcon name={'IcRebuyColor'} size={32} className={'mb-2'}/>
            <div className={'text-secondary font-size-14'}>{getLangPath('user_statuses.respawn.title')} <BinIcon
                name={'IcMoveRight'}/></div>
        </UserStatusRespawnStyled>}
        widgetName={'respawn'}
    >
        <div className={'d-flex flex-column align-items-center font-size-14'}>
            <BinIcon name={'IcRebuyColor'} size={32} className={'mb-2'}/>
            <div className={'text-secondary'}>{getLangPath('user_statuses.respawn.title')}</div>
            <div className={'align-self-start mt-3'}>{getLangPath('user_statuses.respawn.description')}</div>
        </div>
    </UserStatusWidgetWrapper>;
}

export default UserStatusRespawn;
